'use client';

import _slicedToArray from "/codebuild/output/src3703/src/s3/01/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import cx from 'clsx';
var EMPTY_CLASS_NAMES = {};
function mergeClassNames(objects) {
  var merged = {};
  objects.forEach(function (obj) {
    Object.entries(obj).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      if (merged[key]) {
        merged[key] = cx(merged[key], value);
      } else {
        merged[key] = value;
      }
    });
  });
  return merged;
}
function resolveClassNames(_ref3) {
  var theme = _ref3.theme,
    classNames = _ref3.classNames,
    props = _ref3.props,
    stylesCtx = _ref3.stylesCtx;
  var arrayClassNames = Array.isArray(classNames) ? classNames : [classNames];
  var resolvedClassNames = arrayClassNames.map(function (item) {
    return typeof item === "function" ? item(theme, props, stylesCtx) : item || EMPTY_CLASS_NAMES;
  });
  return mergeClassNames(resolvedClassNames);
}
export { resolveClassNames };